import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../../common/customHttp.service';
import { ApiUrl } from '../../../common/apiUrls';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ValidationService } from '../../../common/validationservice';
import { MainAppComponent } from '../../../layout/layout.component';
import 'rxjs/add/operator/map';
import { ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material';
import { SendMailViewModel } from '../../../common/viewModels/Admin/CustomerModel';
declare var $: any;

@Component({
    selector: "sendmail",
    templateUrl: "./sendmail.component.html",
    styleUrls: ["./sendmail.component.scss"]
})

export class SendMailComponent implements OnInit {
    sendMailForm: FormGroup;
    disableToField: boolean = true;
    isSubmitted: boolean = false;
    visible: boolean = true;
    selectable: boolean = true;
    removable: boolean = true;
    addOnBlur: boolean = true;
    sendMailDto: SendMailViewModel = new SendMailViewModel();
    regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    excelFile: FormData = new FormData();

    // Enter, comma
    separatorKeysCodes = [ENTER];

    ngOnInit() {

        this.CreateForm();
        let jobCardId = this._route.snapshot.params['id'];
        this.GetCustomerMailFromJobCardId(jobCardId);
        this.SetDefaultValues();
    }
    constructor(public _router: Router,
        private _mApp: MainAppComponent, private formBuilder: FormBuilder,
        private _http: CustomHttp,
        private _appUrl: ApiUrl, private _route: ActivatedRoute,
        private _validationService: ValidationService, private _toastrService: ToastrService) {

    }


    CreateForm() {
        this.sendMailForm = this.formBuilder.group({
            JobCardId: [this._route.snapshot.params['id']],
            EmailTo: [''],
            EmailCc: [''],
            EmailBcc: [''],
            Subject: ['', Validators.compose([Validators.required])],
            EmailBody: ['', Validators.compose([Validators.required])],
            AttachedFileName: ['']
        });
    }

    GetCustomerMailFromJobCardId(jobCardId) {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.GetCustomerMailFromJobCardId + jobCardId)
            .subscribe(
                data => {
                    this._mApp.HideLoader();
                    var res = data.json().Result;
                    if (res != null && res != '') {
                        if (this.regexp.test(res))
                            this.sendMailDto.EmailToArray.push(res);

                    }
                    else
                        this.disableToField = false;
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result);
                }
            )
    }

    onSubmit() {
        this.isSubmitted = true;
        let data = this.sendMailDto;
        if (this.sendMailForm.valid) {
            if (this.sendMailDto.EmailToArray.length > 0) {
                this._mApp.ShowLoader();
                let mailDetails = this.sendMailForm.value;

                this.sendMailDto.JobCardId = mailDetails.JobCardId;
                this.sendMailDto.Subject = mailDetails.Subject;
                this.sendMailDto.EmailBody = mailDetails.EmailBody;
                this.sendMailDto.AttachedFileName = mailDetails.AttachedFileName;
                this._http.post(this._appUrl.SendReportAsMailToCustomer, this.sendMailDto)
                    .subscribe(
                        data => {
                            this._mApp.HideLoader();
                            this._toastrService.success(data.json().Result);
                            this._router.navigate(['/jobcardlist']);
                        },
                        error => {
                            this._mApp.HideLoader();
                            this._toastrService.error(error.json().ErrorMessage);
                        }
                    )
            }
            else {
                this._toastrService.error('Please provide to mail');
            }
        }
    }

    SetDefaultValues() {
        let imageSrc = this._appUrl.baseUrl + "/Content/Images/petrolimsignaturenew.jpg";
        let signature = "<p></p><div>Dear Sir,</div><p></p><div>Please find here with attached Oil and Elemental analysis reports.</div><p></p><div style='font-size:10.0pt;font-family:Comic Sans MS;color:#1f497d;'>Warm Regards,</div><p></p><div style='font-size:11.0pt;font-family:Calibri,sans-serif;color:#1f497d'>Phone : 040 23156400</div><div style='font-size:11.0pt;font-family:Calibri,sans-serif;color:#1f497d'>Mobile: +917675043140 • Whats App: +17675043140 • <a href='mailto:amsuvarna@petrolabsindia.com' target='_blank' style='cursor:pointer;'><span style='color:#1155cc;' >lab@<wbr>petrolabsindia.com</span></a> </div><div><img width='750' height='120' src='" + imageSrc + "'</div><p></p><div><span style='font-size:11.0pt;font-family:Calibri,sans-serif;color:#1f497d'><b>Confidentiality Notice: </b></span><span style='font-size:11.0pt;font-family:Calibri,sans-serif;color:black'>This email including all attachments is for the sole purpose of the intended recipient(s) and may contain confidential information. Any unauthorized use, disclosure, review, use or distribution is prohibited. If you are not the intended recipient, please contact the sender by reply email and destroy all copies of the original message.</span> </div>";

        this.sendMailDto.EmailCcArray.push('admin@petrolabsindia.com');
        this.sendMailForm.controls['Subject'].setValue('Oil and Elemental analysis reports');
        this.sendMailForm.controls['EmailBody'].setValue(signature);
    }

    add(event: MatChipInputEvent, mailType: string): void {
        let input = event.input;
        let value = event.value;
        if ((value || '').trim()) {
            if (this.regexp.test(value.trim()))
                switch (mailType) {
                    case 'to':
                        this.sendMailDto.EmailToArray.push(value.trim());
                        break;
                    case 'cc':
                        this.sendMailDto.EmailCcArray.push(value.trim());
                        break;
                    case 'bcc':
                        this.sendMailDto.EmailBccArray.push(value.trim());
                        break;
                }
            else
                this._toastrService.error('Please provide valid email');
        }

        if (input) {
            input.value = '';
        }
    }

    remove(mail: any, mailType: string): void {
        let index;
        switch (mailType) {
            case 'to':
                index = this.sendMailDto.EmailToArray.indexOf(mail);
                if (index >= 0) {
                    this.sendMailDto.EmailToArray.splice(index, 1);
                }
                break;
            case 'cc':
                index = this.sendMailDto.EmailCcArray.indexOf(mail);
                if (index >= 0) {
                    this.sendMailDto.EmailCcArray.splice(index, 1);
                }
                break;
            case 'bcc':
                index = this.sendMailDto.EmailBccArray.indexOf(mail);
                if (index >= 0) {
                    this.sendMailDto.EmailBccArray.splice(index, 1);
                }
                break;
        }
    }

    UploadExcelReport(event: any) {
        this.excelFile = new FormData();
        //this.ferroFiles = [];
        var element = ((window.event) ? (event.srcElement) : (event.currentTarget));
        var srcElement = event.srcElement || event.target;
        var files = srcElement.files;
        var size = files[0].size / 1024;
        if (size < 10000) {
            let formData = new FormData();

            for (let i = 0; i < files.length; i++) {
                var ext = files[i].name.split('.').reverse()[0].toLowerCase();
                this.excelFile = new FormData();
                this.excelFile.append("uploads[]", files[i], files[i].name);
                var fileName = files[i].name.split('.').slice(0, -1).join('.');
                this.SaveImportedSampleReport();
            }
        }
        else {
            this._toastrService.error("Cannot upload more than 10 mb files.");
            $("#fileUpload").val('');
            this.sendMailForm.controls['AttachedFileName'].setValue(null);
        }
    }

    SaveImportedSampleReport() {
        this._mApp.ShowLoader();
        this._http.postUpload(this._appUrl.SaveMailAttachedReport, this.excelFile)
            .subscribe(
                data => {
                    this._mApp.HideLoader();
                    var res = data.json().Result;
                    if (res != null && res != '') {
                        this.sendMailForm.controls['AttachedFileName'].setValue(res);
                    }
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result);
                    this.sendMailForm.controls['AttachedFileName'].setValue(null);

                }
            )
    }


}
